import CoursePage from "./Pages/Course/CoursePage";
import ActivitiesPage from "./Pages/Activities/ActivitiesPage";
import ObjectivesPage from "./Pages/Objectives/ObjectivesPage";

export const Classic = {
  Course: CoursePage,
  Activities: ActivitiesPage,
  Objectives: ObjectivesPage,
};
